import { useInView } from 'react-intersection-observer'
import Skeleton from './Skeleton'

interface ProductCardSkeletonProps {
  listView: boolean
  showSideNav: boolean
  categoryId: string
  showCategoryDetails: (categoryId: string) => void
}

const ProductCardSkeleton = ({
  listView,
  showSideNav,
  categoryId,
  showCategoryDetails,
}: ProductCardSkeletonProps): JSX.Element => {
  const { ref } = useInView({
    onChange: (inView) => {
      if (inView) {
        showCategoryDetails(categoryId)
      }
    },
  })

  // Calculate column width based on view type
  const getColumnWidth = () => {
    if (listView) {
      return 'w-full'
    }
    if (showSideNav) {
      return 'lg:w-1/3'
    }
    return 'lg:w-1/4'
  }

  return (
    <div ref={ref} className={`w-1/2 ${getColumnWidth()} p-2 lg:p-4`}>
      <div className="h-40 rounded-lg bg-white shadow">
        <Skeleton
          className="h-full w-full"
          primaryColor="#BBBBBB"
          secondaryColor="#E0E0E0"
          animate={true}
        />
      </div>
    </div>
  )
}

export default ProductCardSkeleton
